export const INIT = 'STRONA_PRZEDMIOTU/INIT';

export const GET_LEFT_PANEL_DATA_START = 'STRONA_PRZEDMIOTU/GET_LEFT_PANEL_DATA_START';
export const GET_DATA_START = 'STRONA_PRZEDMIOTU/GET_DATA_START';

export const COLUMNS_SAVE_USER_SETUP_START = 'STRONA_PRZEDMIOTU/COLUMNS_SAVE_USER_SETUP_START';
export const COLUMNS_GET_CONFIG_START = 'STRONA_PRZEDMIOTU/COLUMNS_GET_CONFIG_START';

export const FILTERS_GET_CONFIG_START = 'STRONA_PRZEDMIOTU/FILTERS_GET_CONFIG_START';
export const FILTERS_REFRESH_VALUES_START = 'STRONA_PRZEDMIOTU/FILTERS_REFRESH_VALUES_START';

export const RECORD_GET_DETAILS_START = 'STRONA_PRZEDMIOTU/RECORD_GET_DETAILS_START';

export const REFRESH_DATA_START = 'STRONA_PRZEDMIOTU/REFRESH_DATA_START';
export const REFRESH_SELECTED_DATA_START = 'STRONA_PRZEDMIOTU/REFRESH_SELECTED_DATA_START';

export const DATA_GET_CSV_START = 'STRONA_PRZEDMIOTU/DATA_GET_CSV_START';

export const SYNC_DATA_WITH_CACHE_START = 'STRONA_PRZEDMIOTU/SYNC_DATA_WITH_CACHE_START';

export const STUDENTS_COPY_FINAL_MARKS_START = 'STRONA_PRZEDMIOTU/STUDENTS_COPY_FINAL_MARKS_START';
export const STUDENTS_COPY_FINAL_MARKS_SUCCESS = 'STRONA_PRZEDMIOTU/STUDENTS_COPY_FINAL_MARKS_SUCCESS';
export const STUDENTS_COPY_FINAL_MARKS_FAIL = 'STRONA_PRZEDMIOTU/STUDENTS_COPY_FINAL_MARKS_FAIL';

export const GET_DATA_STUDENT_LIST_WITH_MARKS_START = 'DYNAMIC_TAB/GET_DATA_STUDENT_LIST_WITH_MARKS_START';
export const GET_DATA_STUDENT_LIST_WITH_MARKS_SUCCESS = 'DYNAMIC_TAB/GET_DATA_STUDENT_LIST_WITH_MARKS_SUCCESS';
export const GET_DATA_STUDENT_LIST_WITH_MARKS_FAIL = 'DYNAMIC_TAB/GET_DATA_STUDENT_LIST_WITH_MARKS_FAIL';
export const GET_DATA_STUDENT_LIST_WITH_MARKS_CANCEL = 'DYNAMIC_TAB/GET_DATA_STUDENT_LIST_WITH_MARKS_CANCEL';